import {
  IHouse,
  IHousesShortInfo,
  IResponseShort,
  TRentPeriod
} from "interfaces/intarfaces";
import { ServiceApi } from "../utils/utilAmplify";
import query from "../utils/query";
import { ServiceName } from "../config/amplify";

class HouseAPIClass {
  private readonly api: ServiceApi;

  constructor() {
    this.api = new ServiceApi(ServiceName.HostHouse);
  }
  updateHouse(
    id: string,
    body: Partial<IHouse>
  ): Promise<IHouse & TRentPeriod> {
    return this.api.patch(id, body);
  }
  createHouse(body: Partial<IHouse>): Promise<IHouse & TRentPeriod> {
    return this.api.post("", body);
  }
  getHouse(id: string): Promise<IHouse & TRentPeriod> {
    return this.api.get(id);
  }
  deleteHouse(id: string) {
    return this.api.del(id);
  }
  getHouses(userId: string): Promise<IHousesShortInfo[]> {
    return this.api.get("?" + query.stringify({ user_id: userId }));
  }
  changeLiked(
    isLiked: boolean,
    studentId: string,
    hostId: string,
    houseId: string
  ): Promise<IResponseShort> {
    return this.api.post((isLiked ? `un-like` : `like`) + "/" + houseId, {
      student_id: studentId,
      host_id: hostId,
      house_id: houseId
    });
  }
  togglePublishing(id: string): Promise<IHousesShortInfo> {
    return this.api.post(`${id}/toggle-publishing`);
  }
  republishHouse(id: string, data: Partial<IHouse>): Promise<IHousesShortInfo> {
    return this.api.post(`${id}/re-publish`, data);
  }
  availableByRadius(params: {
    userId: string;
    lat: number;
    lon: number;
    radiusInMeters: number;
    languages: string[];
    gender: string;
    age: number;
    price?: number;
    area?: number;
    dateFrom?: string;
    dateTo?: string;
    isLiked?: boolean;
  }): Promise<{ items: IHouse[]; next_batch_token: string | null }> {
    return this.api.get(
      "available-by-radius?" +
        query.stringify(
          {
            latitude: params.lat,
            longitude: params.lon,
            radius_in_meters: params.radiusInMeters,
            user_id: params.userId,
            languages: params.languages,
            gender: params.gender,
            age: params.age,
            price: params.price,
            area: params.area,
            date_from: params.dateFrom,
            date_to: params.dateTo,
            is_liked: params.isLiked
          },
          {
            arrayFormat: "repeat"
          }
        )
    );
  }
  uploadPhoto(
    houseID: string,
    body: File | string,
    timestamp: number,
    order: number
  ) {
    const formData = new FormData();
    formData.append("image", body);

    return this.api.post(
      `${houseID}/photos?` + query.stringify({ timestamp, order }),
      formData,
      {
        headers: {
          Accept: "image/*"
        }
      }
    );
  }
  deletePhotos(houseID: string, fileNames: string[]) {
    return this.api.del(`${houseID}/photos`, {
      file_names: fileNames
    });
  }
  reorderPhotos(
    houseID: string,
    order: { file_name: string; order: number }[]
  ) {
    return this.api.post(
      `${houseID}/set-photos-order`,
      { order_data: order },
      {
        headers: {
          Accept: "image/*"
        }
      }
    );
  }
}

export const HouseAPI = new HouseAPIClass();
